module.exports = "SELECT cartodb_id,\n         iso,\n         country,\n         jurisdiction\nFROM jurisdictions;\n"